import { render } from "./SendOtp.vue?vue&type=template&id=7b9d0700"
import script from "./SendOtp.vue?vue&type=script&lang=js"
export * from "./SendOtp.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__